import React, { useState } from 'react';
import { ShoppingBagIcon, ZapIcon, ChevronRightIcon, InfoIcon } from 'lucide-react';
import { Button } from './common/Button';
import { Popup } from './common/Popup';
export function HeroSection() {
  const [showPopup, setShowPopup] = useState(false);
  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowPopup(true);
  };
  const handleOkClick = () => {
    setShowPopup(false);
    window.open('https://kraya.app/', '_blank');
  };
  return <section className="relative overflow-hidden pt-16 pb-20" data-id="element-184">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-186">
          {/* Text content */}
          <div className="mb-12 md:mb-0 md:w-1/2 md:pr-8" data-id="element-187">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-188">
              <span className="block" data-id="element-189">Shop Local.</span>
              <span className="block" data-id="element-190">Get Rewarded.</span>
              <span className="block text-[#A020F0]" data-id="element-191">No QR Codes.</span>
            </h1>
            <p className="text-lg text-gray-600 mb-8" data-id="element-192">
              Earn rewards automatically when you shop in person. No points or
              coupon codes. Just fun!
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-193">
              <Button variant="primary" size="lg" href="https://kraya.app/" onClick={handleDownloadClick} data-id="element-194">
                Download App
              </Button>
            </div>
          </div>

          {/* Hero phone mockup */}
          <div className="relative md:w-1/2 md:flex md:justify-center" data-id="element-195">
            <div className="relative bg-black p-3 rounded-[3rem] shadow-xl max-w-xs mx-auto transform hover:rotate-1 transition-transform duration-300" data-id="element-196">
              {/* Decorative elements - moved inside the transform container */}
              <div className="absolute -top-6 -right-6 bg-[#FFDE59] h-12 w-12 rounded-full animate-pulse" data-id="element-197"></div>
              <div className="absolute -bottom-6 -left-6 bg-[#A020F0] h-8 w-8 rounded-full animate-bounce" data-id="element-198"></div>
              <div className="absolute top-1/3 -right-4 bg-white shadow-lg rounded-lg p-2 animate-float" data-id="element-199">
                <div className="flex items-center" data-id="element-200">
                  <ZapIcon className="h-4 w-4 text-[#FFDE59] mr-1" data-id="element-201" />
                  <span className="text-xs font-bold" data-id="element-202">+10 Drops!</span>
                </div>
              </div>

              <div className="bg-white rounded-[2.5rem] overflow-hidden" data-id="element-203">
                {/* App screenshot */}
                <div className="pt-6 px-6 pb-12 bg-gradient-to-b from-[#f9f5ff] to-white" data-id="element-204">
                  {/* App header */}
                  <div className="flex items-center justify-between mb-6" data-id="element-205">
                    <div className="text-base font-medium" data-id="element-206">Hey, Arjun! 👋</div>
                    <div className="h-8 w-8 bg-[#FFDE59] rounded-full" data-id="element-207"></div>
                  </div>

                  {/* Featured section */}
                  <div className="bg-white rounded-xl shadow-sm p-4 mb-4" data-id="element-208">
                    <div className="flex items-center mb-2" data-id="element-209">
                      <ShoppingBagIcon className="h-5 w-5 text-[#A020F0] mr-2" data-id="element-210" />
                      <h3 className="font-medium" data-id="element-211">Featured Rewards</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-2" data-id="element-212">
                      <div className="rounded-lg h-16 overflow-hidden" data-id="element-213">
                        <img src="https://images.unsplash.com/photo-1509042239860-f550ce710b93" alt="Coffee shop" className="w-full h-full object-cover" data-id="element-214" />
                      </div>
                      <div className="rounded-lg h-16 overflow-hidden" data-id="element-215">
                        <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5" alt="Restaurant" className="w-full h-full object-cover" data-id="element-216" />
                      </div>
                      <div className="rounded-lg h-16 overflow-hidden" data-id="element-217">
                        <img src="https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0" alt="Retail store" className="w-full h-full object-cover" data-id="element-218" />
                      </div>
                      <div className="rounded-lg h-16 overflow-hidden" data-id="element-219">
                        <img src="https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9" alt="Bakery" className="w-full h-full object-cover" data-id="element-220" />
                      </div>
                    </div>
                  </div>

                  {/* Nearby section */}
                  <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-221">
                    <div className="flex items-center mb-2" data-id="element-222">
                      <ZapIcon className="h-5 w-5 text-[#FFDE59] mr-2" data-id="element-223" />
                      <h3 className="font-medium" data-id="element-224">Nearby Spots</h3>
                    </div>
                    <div className="space-y-2" data-id="element-225">
                      <div className="flex items-center" data-id="element-226">
                        <div className="h-10 w-10 rounded-lg mr-3 overflow-hidden" data-id="element-227">
                          <img src="https://images.unsplash.com/photo-1559925393-8be0ec4767c8" alt="Coffee shop" className="w-full h-full object-cover" data-id="element-228" />
                        </div>
                        <div data-id="element-229">
                          <div className="text-sm font-medium" data-id="element-230">
                            Morning Brew
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-231">
                            0.2 miles away
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-232">
                        <div className="h-10 w-10 rounded-lg mr-3 overflow-hidden" data-id="element-233">
                          <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5" alt="Restaurant" className="w-full h-full object-cover" data-id="element-234" />
                        </div>
                        <div data-id="element-235">
                          <div className="text-sm font-medium" data-id="element-236">
                            Local Bistro
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-237">
                            0.5 miles away
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-238">
                        <div className="h-10 w-10 rounded-lg mr-3 overflow-hidden" data-id="element-239">
                          <img src="https://images.unsplash.com/photo-1472851294608-062f824d29cc" alt="Bookstore" className="w-full h-full object-cover" data-id="element-240" />
                        </div>
                        <div data-id="element-241">
                          <div className="text-sm font-medium" data-id="element-242">Page Turner</div>
                          <div className="text-xs text-gray-500" data-id="element-243">
                            0.7 miles away
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Popup */}
      <Popup isOpen={showPopup} onClose={() => setShowPopup(false)} title={<div className="flex items-center gap-2" data-id="element-245">
            <InfoIcon className="h-5 w-5 text-[#A020F0]" data-id="element-246" />
            <span data-id="element-247">Note</span>
          </div>} data-id="element-244">
        <div className="space-y-4" data-id="element-248">
          <p className="text-gray-600" data-id="element-249">
            Please note this is a demo app; not all features may be functional.
            Stay tuned for our launch.
          </p>
          <Button variant="primary" size="full" onClick={handleOkClick} data-id="element-250">
            OK
          </Button>
        </div>
      </Popup>

      <style jsx data-id="element-251">{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0px);
          }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </section>;
}